module.exports={
    btn:{
        "tips_reelect_btn":"新しい画像",
        "cancel_btn":"キャンセル",
        "continue_dispose":"サポートされている画像をアップスケール",
        "tips_return":"新しい画像",
        "tips_upgrade":"アップグレード",
        "tips_yes":"OK",
        "delete":"削除",
        "download":"ダウンロード",
        "upload_image":"画像をアップロードする",
        "new_image":"新しい画像",
        "save_all":"すべて保存",
        "cancel":"キャンセル",
        "save":"保存",
        "view_comparison":"比較をプレビューする",
        "hide_comparison":"比較を非表示にする",
        "previous":"前",
        "next":"次",
        "continue_download":"ウォーターマーク付きの画像を保存する",
        "present":"この画像に適用する",
        "all_wait":"待機中の画像に適用する",
        "all":"すべての画像に適用する",
        "history":"履歴",
        "login":"ログイン",
    },
    tips:{
        "please_upgrade":"現在のプランでは画像のバッチ処理はサポートされていません。より多くの機能を利用するには、プランをアップグレードしてください。",
        "errorlistinfo":"XXXつのファイルが選択されました。XXX枚の画像は処理をサポートしますが、XXXつのファイルはサポートしません。次はサポートされていないファイルです。",
        "max":"10MBのサイズ制限を超えました!",
        "max_size":"最長辺が4096pxというサイズ制限を超えています！",
        "continue_dispose":"サポートされているイメージを拡大する",
        "please_multiple":"倍率を選択してください。",
        "max_multiple":"※画像は4Kまで拡大可能(最長辺4096pxを超えない)。",
        "title":"ファイル名",
        "reasons":"原因",
        "upload_type":"形式がサポートされていない",
        "used_up":"これ以上ウォーターマークなしの高解像度画像をダウンロードできません。再度アップグレードするか、ウォーターマーク付きの画像をダウンロードしてください。",
        "edit_multiple":"複数の画像がアップロードされています。倍率を変更したい画像を選択してください。選択すると、これらの画像は新しい倍率に再度アップスケールされます。",
        "download_confirm":"一部の画像はまだ処理中です。アップスケールした画像をすべて保存してもよろしいですか? 同じ画像を繰り返し保存する場合は、保存画像数が別に再度減算されません。",
        "waiting_save":"一部の画像はまだ処理中です。後で保存してください。",
        
    },
    header:{
        "title":"Aiseesoft 画像 アップスケーリング",
        "hd":" HD画像",
        "watermarks":"ウォーターマークなしでダウンロードできます。",
        "view_details":"詳細を見る",
        "loading":"読み込み中…",
    },
    content:{
        "failed":"失敗した",
        "completed":"完了",
        "processing":"処理中",
        "img_processing":"処理中…",
        "img_failed":"処理に失敗した",
        "uploading":"アップロード中",
        "img_uploading":"アップロード中…",
        "wait_upoading":"アップロードを待っている…",
        "waiting":"待っている",
        "img_waiting":"待っている…",
        "empty":"空き",
        "magnification":"倍率：",
        "drop":"または、画像ファイルをここにドロップして、スケールアップして強化します。",
        "original":"オリジナル画像：",
        "output":"出力画像：",
        img_rendering1:"画像がアップスケールされました。",
        img_rendering2:"プレビューできるよう高品質のイメージをレンダリング中です。お待ちください...",
        no_watermark:"保存後、画像には透かしがありません。",
    },
    "banner_msg":"Image Upscaler のプランを選択する",
    "monthly":"月間",
    "lifetime":"永久版",
    "choose_plan":"画像の数に応じてプランを選択してください",
    "return_home":"おめでとう！正常にアップグレードされました。この製品を使用するには、ホームページに戻ってください",
    "congratulations":"おめでとう！正常にアップグレードされました。特典はアップグレード時に残した電子メールアドレスにバインドされます。電子メールに登録、またはリンクされているアカウントを使用してください。",
    "login_benefits":"ログインして特典を利用する",
    "no_registered":"。 メールアドレスを登録またはアカウントにリンクしていない場合は、",
    "register_account":"電子メールを使用してアカウントを登録する",
    "other_accounts":"または、特典を使用するために他のアカウントをこの電子メールアドレスにリンクします。",
    "btn_close":"閉じる",
    "free":"フリー",
    "btn_get_started":"スタート",
    "access_to":"アクセス",
    "upscale_images":"ハイビジョン画像",
    "up_to":"最高",
    "per_image":"画像は一枚ずつ",
    "resolution_of":"解像度が最大で",
    "default_level":"デフォルトレベルの高級画像",
    "image_downloads":"透かしなしのハイビジョン画像を2枚ダウンロード可能。",
    "unlimited_image":"ウォーターマーク付きの画像を無制限にダウンロード可能",
    "SHA256_encryption":"SHA256暗号化技術",
    "mon":"每月",
    "images":"画像",
    "high_resolution":"高解像度の品質で",
    "tax_incl":"税込み",
    "image":"枚",
    "secure_checkout":"安全な支払い",
    "everything":"すべてが無料で、",
    "upscaling_levels":"すべてのアップスケーリングレベルを選択可能",
    "unlimited_image_without":"ウォーターマークなしの画像を無制限にダウンロード可能",
    "viewable_editing":"編集履歴は次の有効期間で表示可能とおりです。",
    "days":"日",
    "high_level":"ハイレベル",
    "priority_processing":"  優先処理",
    "left":"永久版",
    "resolution":"解像度",


    "history_will":"有効期限が切れるのは次のとおりです",
    "history.days":"日",
    "history.hours":"時間",
    "expired":"期限切れ",
    "access_to":"無料版では下記の機能が利用できる",
    "pricing.upload_images":"画像をアップロードする",
    "pricing.under":"未満",
    "pricing.images":"枚の画像",
    "pricing.without_watermark":"透かしなし",
    "pricing.process_images":"画像は最大で",
    "pricing.pixels":"ピクセルにアップスケール可能",
    "pricing.enjoy_limited":"サブスクリプション特典は無料で利用できる",
    "pricing.download":"ダウンロード",
    "pricing.HD_images":"枚の透かしなしのHD画像",
    "pricing.and_you":"次のような状況に出遭うかもしれません",
    "pricing.slow_upscaling":"アップスケーリングするには時間がかかる",
    "pricing.lower_priority":"優先度が低い",
    "pricing.without":"透かしなし",
    "pricing.tax":"消費税は販売価格に含まれており、お住まいの国と地域に基づいて自動的に計算されます。ショッピングカート内で詳細な税額をご確認いただけます。最終的なお支払い金額は表示価格と同額となります。",
    "pricing.you_can":"サブスクリプションを契約すると、",
    "pricing.up_to":"アップロードの画像は最大で",
    "pricing.upscale_images":"透かしなしで",
    "pricing.no_watermark":"画像を拡大する",
    "pricing.enhance":"",
    "pricing.or_more":"枚、またはそれ以上の画像",
    "pricing.in_batch":"パッチ処理して",
    "pricing.enlarge_images":"画像を拡大できる",
    "pricing.and":"そして",
    "pricing.times_with":"回数制限なしで画像を拡大できる",
    "pricing.enjoy":"履歴の保存時間",
    "pricing.of_history":"を利用できる",
    "pricing.experience":"高速でアップスケーリング",
    "pricing.fast_upscaling":"できる",
    "pricing.higher_priority":"優先度が高い",
    "pricing.early_access":"他人よりも早く新機能を楽しめる",
    "pricing.cancel_anytime":"いつでもキャンセル可能",
    "pricing.lifetime_license":"永久版を使うと、次のことができます",
    "pricing.and_there":"そして利用可能のクレジットがある限り",
    "pricing.no_expiration":"有効期限なしで",
    "pricing.unless":"画像を拡大できる",

    "buynow.pop.credit":"クレジット",
    "buynow.pop.credits":"クレジット",

    "isUnderequityTip_msg1":"バッチ処理に{%}枚の画像を選択しましたが、残りの特典が足りず、{%}クレジットが必要です（現在、特典が{%}クレジット残っています）。処理が必要な場合は、画像処理を続行するために特典をご購入ください。",
    "isUnderequityTip_msg2":"バッチ処理に{%}枚の画像を選択しましたが、残りの特典が足りず、{%}クレジットが必要です（現在、特典が{%}枚残っています）。処理が必要な場合は、画像処理を続行するために特典をご購入ください。",
    "isUnderequityTip_msg3":"バッチ処理に{%}枚の画像を選択しましたが、残りの特典が足りず、{%}クレジットが必要です（現在、特典が{%}クレジット、{%}枚残っています）。処理が必要な場合は、画像処理を続行するために特典をご購入ください。",
    "btn_buy_now":"今すぐ購入",
    "isEquityDepletionTip_msg":"特典が使い切れました。バッチ処理にはご購入ください",

    "pricing.h1":"Aiseesoft AI Photo Editor - プランと価格",
    "pricing.banner_content":"AI Photo Editorのクレジットを取得して、画像の背景を削除したり、画像をアップスケールしたり、オンラインまたはデスクトップから画像からオブジェクトを削除したりできます。",
    "pricing.best_seller":"ベストセラー",
    "pricing.monthly":"月額サブスクリプション",
    "pricing.credits":"クレジット",
    "pricing.lifetime":"永久ライセンス",
    "pricing.note":"注意",
    "pricing.buy_now":"今すぐ購入",
    "pricing.note_content":"購入したクレジットは、ショッピングカートに入力したメールアドレスに紐付けられています。これらのクレジットを使用するには、同じメールアドレスを使用して登録またはログインしてください。",

    "header.buy_more":"さらに購入",
    "header.available_credits":"利用可能なクレジット",
    "header.credits":"クレジット"
}